
jQuery(document).ready(function() {
const $ = jQuery;

$('.sections--part-of-team form').submit(function( event ) {
    event.preventDefault();
    let queries = {
        inputName: $('.inputName').val(),
        inputMail: $('.inputMail').val(),  
        inputPhone: $('.inputPhone').val(),
        selecType: $('.selecType').val(),
        textArea: $('.textArea').val()  
    }  
       
    let check  = true;
    // let loading = new Loading('.set-part');

    $.each(queries, function (key, qu) {
        if (!qu) {
            if (key !== 'inputPhone' && key !== 'textArea') {
                $('.' + key).addClass('required');
                check = false;
            }
        }
        else {
            $('.' + key).removeClass('required');
        }
    });

    if (!validateEmail(queries.inputMail)) {
        $('.inputMail').addClass('required');
        check = false;
    }

if (check) {
    // loading.build('.set-part');
    let loading = new Loading('body');
    loading.build();
    loading.open();
    queries.selecType = $('.'+ $('.selecType').val()).text();
    ajaxReq('POST', queries, '/wp-admin/admin-ajax.php?action=wpse_sendmail', (data) => {
        window.location.replace("/thank-you");
    }, loading);
}

});

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function ajaxReq(typeAjax, dataAjax, url, ajaxSuccess, loading) {
    var aj = {
        type: typeAjax,
        url: url,
    }
    if (dataAjax) aj.data = dataAjax;
    $.ajax(aj)
        .done(function (res) {
            ajaxSuccess(res);
            // let loading = new Loading($loading);
            // loading.remove();
        })
        .fail(function (res) {
            // let loading = new Loading($loading);
            // loading.remove();
            // let loading = new Loading();
            loading.remove();
        })
}
});

